// extracted by mini-css-extract-plugin
module.exports = {"link-button":"text-button_link-button__VJuVL","bold":"text-button_bold__FlVD5"};